import { AnnotationStatus } from '@rossum/api-client/shared';

export const snakeCaseStatuses = [
  'created',
  'exporting',
  'deleted',
  'confirmed',
  'exported',
  'failed_export',
  'failed_import',
  'reviewing',
  'to_review',
  'importing',
  'split',
  'purged',
  'rejected',
  'postponed',
  'in_workflow',
] as const;

export type SnakeCaseStatus = AnnotationStatus;
